import type { Ledger } from '@/api/types';

/**
 * Checks if a ledger is archived.
 *
 * CONTRACT: This is the canonical implementation for archive status checks.
 * All backend implementations (PHP, Go) MUST use the same logic.
 * See: api/src/Domain/Config/AppConfig.php for full contract documentation.
 *
 * Archive Status Contract:
 *   - archivedAt === null: NOT archived
 *   - archivedAt === 0: NOT archived (explicit unarchive)
 *   - archivedAt > 0: ARCHIVED (Unix timestamp when archived)
 *
 * Canonical check: (archivedAt !== null && archivedAt > 0)
 *
 * Backend notes:
 *   - PHP returns null for unset timestamps, 0 for explicit unarchive
 *   - Go must handle nil vs 0 distinction appropriately
 *   - JSON serialization: null should remain null, not become 0
 */
export function isLedgerArchived(ledger: Pick<Ledger, 'archivedAt'>): boolean {
    return ledger.archivedAt !== null && ledger.archivedAt > 0;
}
